import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-afe9c4ec")

_pushScopeId("data-v-afe9c4ec")
const _hoisted_1 = { class: "scheme-list-box" }
const _hoisted_2 = { class: "scheme-list-body" }
const _hoisted_3 = { class: "scheme-list-body__main" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { style: {"margin-left":"5px"} }, "专属睡眠改善方案", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("获取睡眠改善方案")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_col = _resolveComponent("van-col")
  const _component_van_row = _resolveComponent("van-row")
  const _component_van_cell = _resolveComponent("van-cell")
  const _component_van_list = _resolveComponent("van-list")
  const _component_van_button = _resolveComponent("van-button")
  const _component_van_sticky = _resolveComponent("van-sticky")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_van_list, {
          loading: _ctx.loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item,
                onClick: ($event: any) => (_ctx.toHealthInfoPage(item.solutionId))
              }, {
                title: _withId(() => [
                  _createVNode(_component_van_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_van_col, { span: "4" }, {
                        default: _withId(() => [
                          _createVNode(_component_van_image, {
                            style: {"vertical-align":"middle","margin-top":"9px"},
                            fit: "sca",
                            "lazy-load": "",
                            width: "30px",
                            height: "35px",
                            src: _ctx.schemeListItemImg
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, { span: "20" }, {
                        default: _withId(() => [
                          _createVNode(_component_van_row, null, {
                            default: _withId(() => [
                              _createVNode(_component_van_col, {
                                span: "24",
                                class: "yichu"
                              }, {
                                default: _withId(() => [
                                  _createVNode("span", {
                                    textContent: _toDisplayString(item.userName)
                                  }, null, 8, ["textContent"]),
                                  _hoisted_4
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_van_col, {
                                span: "24",
                                style: {"margin-top":"5px"}
                              }, {
                                default: _withId(() => [
                                  _createVNode("span", {
                                    textContent: _toDisplayString(item.formatPayTime)
                                  }, null, 8, ["textContent"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ])
    ]),
    _createVNode(_component_van_sticky, {
      "offset-bottom": 20,
      position: "bottom",
      "safe-area-inset-bottom": "",
      style: {"margin":"25px 0"}
    }, {
      default: _withId(() => [
        _createVNode(_component_van_row, null, {
          default: _withId(() => [
            _createVNode(_component_van_col, {
              span: "20",
              offset: "2"
            }, {
              default: _withId(() => [
                _createVNode(_component_van_button, {
                  onClick: _ctx.toHealthPage,
                  type: "primary",
                  color: "rgb(116, 83, 213)",
                  round: true,
                  size: "normal",
                  block: ""
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})